module.exports = __webpack_public_path__ + "static/img/f.283b306.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/mobile/photo_pack/f.png
// module id = BK20
// module chunks = 12